import React from 'react';
import { Link } from 'react-router-dom';

import './PurchaseConfirmation.scss';
import FormHeader from '../FormHeader/FormHeader';
import Skeleton from 'react-loading-skeleton';
import Currency from '../Currency';
import testDrive from '../../images/test-drive.svg';
import virtualTour from '../../images/virtual-tour-icon.svg';
import virtualAppraisal from '../../images/virtual-appraisal.svg';
import estrenar from '../../images/estrenar.svg';
import Button from '../Button';
import useMoment from '../../utils/hooks/useMoment';
import LocalSkeleton from '../Skeleton';
import Steps from '../Steps';


const Loader = () => (
  <LocalSkeleton>
    <div className="purchase-skeleton">
      <div className="purchase-skeleton__section">
        <div className="purchase-skeleton__title skeleton__box" />
        <div className="purchase-skeleton__field skeleton__box" />
        <div className="purchase-skeleton__field skeleton__box" />
        <div className="purchase-skeleton__field skeleton__box" />
      </div>
      <div className="purchase-skeleton__section">
        <div className="purchase-skeleton__title skeleton__box" />
        <div className="purchase-skeleton__field skeleton__box" />
        <div className="purchase-skeleton__field skeleton__box" />
        <div className="purchase-skeleton__field skeleton__box" />
      </div>
      <div className="purchase-skeleton__section">
        <div className="purchase-skeleton__title skeleton__box" />
        <div className="purchase-skeleton__field skeleton__box" />
        <div className="purchase-skeleton__field skeleton__box" />
        <div className="purchase-skeleton__field skeleton__box" />
      </div>
    </div>
  </LocalSkeleton>
);

const PurchaseConfirmation = ({ isLoading, reservation, reservationId, error }) => {
  const steps = [
    {
      id: 1,
      image: testDrive,
      title: "Test drive",
      button: <Button component={Link} to={'/test-drive'} type='red'>Ir</Button>,
      desc: 'Agendá una cita para que podas probar tu vehículo'
    },
    {
      id: 2,
      image: virtualTour,
      title: "Tour virtual",
      button: <Button component={'a'} target="_blank" href={'/?marca=Mitsubishi#tour-virtual__frame'} type='red'>Ir</Button>,
      desc: 'Conocé tu vehículo reservado en nuestro Tour virtual'
    },
    {
      id: 3,
      image: virtualAppraisal,
      title: "Avalúo Virtual",
      button: <Button component={Link} to={'/avaluo'} type='red'>Ir</Button>,
      desc: 'Realizá el avalúo del vehículo que pensás entregar de manera virtual'
    },
    {
      id: 4,
      image: estrenar,
      title: "Estrenar",
      desc: '¡Recordá traer tu cédula!'
    }
  ];
  const reservationDate = useMoment(reservation?.fecha);
  const esCompra = reservation?.esCompra === '1';
  if (error) {
    return (
      <div
        className="purchase-confirmation purchase-confirmation--error gradient gradient--full"
        style={{ '--color': reservation?.datosCarro?.colorCode }}
      >
      <h1>La reserva que intentas ver no existe.</h1>
    </div>
    )
  }
  return (
    <div
      className="purchase-confirmation gradient gradient--full"
      style={{ '--color': reservation?.datosCarro?.colorCode }}
    >
      {!isLoading && (
        <FormHeader
          logoUrl={reservation?.datosCarro?.logoUrl}
          headerText={`${esCompra ? 'Comprar' : 'Reservar'} mi vehículo`}
          headerSubText='Comprá tu chuzo de manera fácil y segura…'
          bottomBorder
        />
      )}
      <div className="purchase-confirmation__content">
        <div className="purchase-confirmation__aside">
          <div className="purchase-confirmation__image">
            {isLoading ? (
              <Skeleton circle={true} height={200} width={200} />
            ) : (
              <img src={reservation?.datosCarro?.imagenGrande} alt="Vehiculo" />
            )}
          </div>
          <h4 className="purchase-confirmation__mobile-header mobile">
            Tu reserva está lista
          </h4>
        </div>
        <div className="purchase-confirmation__main">
          {isLoading ? (
            <LocalSkeleton>
              <div className="purchase-skeleton__title skeleton__box" />
              <div className="purchase-skeleton__title skeleton__box" />
              <div className="purchase-skeleton__title skeleton__box" />
            </LocalSkeleton>
          ) : (
            <>
              <h5 className="purchase-confirmation__section-title">
                Tu {esCompra ? 'compra' : 'reserva'} está lista
              </h5>
              <h5 className="purchase-confirmation__section-title">
                Estas un paso más cerca
              </h5>
              <p className="purchase-confirmation__p">
              Posterior a concretar los pasos de la reservación, se procede con solicitud de crédito, envío de documentación, aprobación bancaria y a !Estrenar!
              </p>
            </>
          )}
        </div>
      </div>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className="purchase-confirmation__data">
            <div className="purchase-confirmation__column">
              <p className="purchase-confirmation__data-text purchase-confirmation__data-text--bold">
                Datos de cliente
              </p>
              <p className="purchase-confirmation__data-text">
                {reservation?.nombreCliente} {reservation?.apellidoCliente}
              </p>
              <p className="purchase-confirmation__data-text">
                Número de identificación {reservation?.idCliente}
              </p>
              <p className="purchase-confirmation__data-text">
                Correo electrónico: {reservation?.email}
              </p>
              <p className="purchase-confirmation__data-text">
                Tel: {reservation?.telefono}
              </p>
            </div>
            <div className="purchase-confirmation__column">
              <p className="purchase-confirmation__data-text purchase-confirmation__data-text--bold">
                Datos de pago
              </p>
              <p className="purchase-confirmation__data-text">
                {esCompra ? 'Compra' : 'Reserva'}
              </p>
              <p className="purchase-confirmation__data-text">
                {esCompra ? 'Pago' : 'Monto'}:{' '}
                <Currency value={reservation?.datosPago?.monto} />
              </p>
              <p className="purchase-confirmation__data-text">
                Tipo de contrato: {reservation?.tipoContrato}
              </p>
            </div>
            <div className="purchase-confirmation__column">
              <p className="purchase-confirmation__data-text purchase-confirmation__data-text--bold">
                Datos de reserva{' '}
              </p>
              <p className="purchase-confirmation__data-text">
                Numero de confirmación {reservation?.numReservaSocace}
              </p>
              <p className="purchase-confirmation__data-text purchase-confirmation__data-text--bold">
                Fecha de validez
              </p>
              <p className="purchase-confirmation__data-text">
                {reservationDate}
              </p>
            </div>
          </div>
          <div className="purchase-confirmation__amount-info">
            <p className="purchase-confirmation__amount">
              Monto de reserva:{' '}
              <Currency value={reservation?.datosPago?.monto} />
            </p>
            <div className="purchase-confirmation__amount-total">
              Total del vehículo{' '}
              {reservation?.cuponId ? (
                <>
                  <Currency value={parseFloat(reservation?.datosCarro?.precioPublico) - parseFloat(reservation?.montoCupon)} />
                  <br /> (Cupón Aplicado de {<Currency value={reservation?.montoCupon} />})
                </>
              ): (
                
                  reservation?.descuentoWeb ? (
                    <Currency value={parseFloat(reservation?.datosCarro?.precioPublico) - (parseFloat(reservation?.descuentoWeb) || 0)} />
                  ):(
                    <Currency value={reservation?.datosCarro?.precioPublico} />
                  )
              )}
            </div>
          </div>
          <div className="purchase-confirmation__next"> 
            <Steps steps={steps} title="Siguientes pasos" subtitle="Estás muy cerca de tu nuevo chuzo…. Estos pasos cambian según la acción, la idea es que sean complemento de la acción realizada." />
          </div>
        </>
      )}
    </div>
  );
};

export default PurchaseConfirmation;
